// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_rxL","colMin":"styles_colMin__3Z1Pg"};